import type { AgentApiCandidateFormItemsShow } from '@/types/serializers';
import type { CandidateFormItemFormType, CandidateFormItemFormatType } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Params = {
  title: string;
  required: boolean;
  item_type: 'manual';
  form_type: CandidateFormItemFormType;
  format_type: CandidateFormItemFormatType;
  placeholder?: string | null;
  description?: string | null;
  suffix?: string | null;
  min_length?: number | null;
  max_length?: number | null;
  options?: string[];
};

/**
 * candidate_form_item作成用のフック（現状はmanual作成に使用）
 */
export default function useCreateCandidateFormItem() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch('/agent/api/candidate_forms/candidate_form_items', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ candidate_form_item: params }),
      });

      if (!response.ok) {
        let errorMessage = '項目の追加に失敗しました';
        try {
          const errorData = await response.json();
          errorMessage = errorData?.errors?.[0] || errorData?.message || errorMessage;
        } catch {
          // noop
        }
        throw new Error(errorMessage);
      }

      const data: AgentApiCandidateFormItemsShow = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
